import track from 'c9-tracking';
import {
  AttentionBanner,
  Button,
  EmailField,
  FormGroup,
  PhoneField,
  TextField,
  TextareaField,
  validateEmail,
  validatePhone,
} from '@flos/react-ui';
import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useResource from '../hooks/resource';
import { navigationActions } from '../store/navigation.slice';
import { submit } from '../store/navigation.thunk';
import { IState } from '../types';

const send = (event: React.FormEvent<HTMLFormElement>, dispatch: Dispatch<any>) => {
  dispatch(submit());
  event.preventDefault();
  return false;
};

const WriteToUs = () => {
  const dispatch = useDispatch();
  const resource = useResource();
  const { navigation, user } = useSelector<IState, IState>((state) => state);

  // Load user details from logon info
  useEffect(() => {
    if (user.activeUser?.name && !navigation.name) {
      dispatch(navigationActions.setName(user.activeUser.name));
    }
    if (user.activeUser?.primaryEmail && !navigation.email) {
      dispatch(navigationActions.setEmail(user.activeUser.primaryEmail));
    }
    if (user.activeUser?.primaryPhone && !navigation.mobile) {
      dispatch(navigationActions.setMobile(user.activeUser.primaryPhone));
    }

    track.ready(true, 'writeToUsFormReady');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h3>{resource('label.header')}</h3>
      <form id="write-to-us-form" onSubmit={(e) => send(e, dispatch)}>
        <FormGroup className="u-Space-up--lg u-Space-down--lg">
          <TextareaField
            name="sas-dnt-freetext"
            required={true}
            label={resource('label.message')}
            value={navigation.message}
            onChange={({ target: { value } }) => dispatch(navigationActions.setMessage(value))}
          />
        </FormGroup>

        <FormGroup className="u-Space-down">
          <h3>{resource('label.header.about-you')}</h3>
          <TextField
            name="name"
            required={true}
            label={resource('label.name')}
            value={navigation.name}
            onChange={({ target: { value } }) => dispatch(navigationActions.setName(value))}
          />
          <EmailField
            name="email"
            required={true}
            label={resource('label.email')}
            value={navigation.email}
            onChange={({ target: { value } }) => dispatch(navigationActions.setEmail(value))}
          />
          <PhoneField
            name="mobile"
            required={true}
            label={resource('label.phone')}
            value={navigation.mobile}
            onChange={({ target: { value } }) => dispatch(navigationActions.setMobile(value))}
          />
        </FormGroup>

        <div className="u-Space-up u-Space-down">
          <Button
            type="submit"
            disabled={
              navigation.submission.status === 'loading' ||
              !(
                validatePhone(navigation.mobile) &&
                validateEmail(navigation.email) &&
                navigation.name.trim() !== '' &&
                navigation.message.trim() !== ''
              )
            }
            isLoading={navigation.submission.status === 'loading'}
          >
            {resource('label.submit')}
          </Button>
        </div>
        {navigation.submission.status === 'error' && <AttentionBanner>{resource('error.submission')}</AttentionBanner>}
      </form>
    </>
  );
};

export default WriteToUs;
